import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BadgeComponent } from './badge.component'
import { RawTextModule } from '../raw-text/raw-text.module'

@NgModule({
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
  imports: [CommonModule, RawTextModule]
})
export class BadgeModule {}
